import { render, staticRenderFns } from "./checkOrderFailedDetail.vue?vue&type=template&id=cb2b1992&scoped=true&"
import script from "./checkOrderFailedDetail.vue?vue&type=script&lang=js&"
export * from "./checkOrderFailedDetail.vue?vue&type=script&lang=js&"
import style0 from "./checkOrderFailedDetail.vue?vue&type=style&index=0&id=cb2b1992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2b1992",
  null
  
)

export default component.exports